import { useState } from "react";
import {
  Container,
  Card,
  Grid,
  MobileStepper,
  Button,
  Typography,
} from "@material-ui/core";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import SwipeImg1 from "../../assets/swipeImg/1.png";
import SwipeImg2 from "../../assets/swipeImg/2.png";
import SwipeImg3 from "../../assets/swipeImg/3.png";
import SwipeImg4 from "../../assets/swipeImg/4.png";
import SwipeImg5 from "../../assets/swipeImg/5.png";
import SwipeImg6 from "../../assets/swipeImg/6.png";
import SwipeImg7 from "../../assets/swipeImg/7.png";
import SwipeImg8 from "../../assets/swipeImg/8.png";
import SwipeImg9 from "../../assets/swipeImg/9.png";
import SwipeImg10 from "../../assets/swipeImg/10.png";
import SwipeImg11 from "../../assets/swipeImg/11.png";

import "./index.less";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const tutorialSteps = [
  {
    imgPath: SwipeImg1,
  },
  {
    imgPath: SwipeImg2,
  },
  {
    imgPath: SwipeImg3,
  },
  {
    imgPath: SwipeImg4,
  },
  {
    imgPath: SwipeImg5,
  },
  {
    imgPath: SwipeImg6,
  },
  {
    imgPath: SwipeImg7,
  },
  {
    imgPath: SwipeImg8,
  },
  {
    imgPath: SwipeImg9,
  },
  {
    imgPath: SwipeImg10,
  },
  {
    imgPath: SwipeImg11,
  },
];

export default function About() {
  const [activeStep, setActiveStep] = useState(0);

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <div className="about">
      <Container maxWidth="lg">
        <Grid
          container
          spacing={4}
          alignContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} md={5} className="about-swipe">
            <Card>
              <AutoPlaySwipeableViews
                axis="x"
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
              >
                {tutorialSteps.map((step, index) => (
                  <div key={index} style={{ background: "#212121" }}>
                    {Math.abs(activeStep - index) <= 2 ? (
                      <img
                        src={step.imgPath}
                        width="100%"
                        alt={String(index)}
                      />
                    ) : null}
                  </div>
                ))}
              </AutoPlaySwipeableViews>
              <MobileStepper
                variant="dots"
                steps={11}
                className="swipe-component"
                position="static"
                activeStep={activeStep}
                nextButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === 10}
                  >
                    <KeyboardArrowRight />
                  </Button>
                }
                backButton={
                  <Button
                    size="small"
                    onClick={handleBack}
                    disabled={activeStep === 0}
                  >
                    <KeyboardArrowLeft />
                  </Button>
                }
              />
            </Card>
          </Grid>
          <Grid item xs={12} md={5} className="about-content">
            <Grid container>
              <Typography component="div" variant="h4" className="about-title">
                About the <span style={{ color: "#ffc938" }}>KungFu Hero</span>
              </Typography>
              <Typography
                component="div"
                variant="h6"
                paragraph
                className="paragraph-text"
              >
                The KungFu Hero is a collection of 10,000 unique
                randomly-generated KungFu-themed NFTs. Several KungFu lovers who
                got inspired by Cryptopunks and Bored Ape Yacht Club came
                together to create a new project. The KungFu Heroes are mostly
                inspired by ancient oriental tales and Asian legends. All KungFu
                Heroes are living, fighting, and socializing in the KungFu
                Metaverse on the Ethereum blockchain (ERC-721). We want to tell
                an interesting KungFu story on the blockchain.
              </Typography>
              <Typography component="div" variant="h4" className="sale-title">
                About the <span style={{ color: "#ffc938" }}>Sale</span>
              </Typography>
              <Typography
                component="div"
                variant="h6"
                paragraph
                className="paragraph-text"
              >
                We will sell 8,800 KungFu Heroes in identical blind boxes
                through our official website. 500 Heroes will be given to NFT
                community for free. 400 will be used in Free treasure hunts open
                to both NFT collectors and KungFu Hero owners. The rest will be
                used for development costs and project promotions. One week
                after the initial launch, the boxes will be opened and all the
                KungFu Heroes will be revealed - TBD.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
